export function fmtMoney(v) {
  const n = Number(v) || 0;
  const a = Math.abs(n);
  let s;
  if (a >= 1e6) s = `$${(a / 1e6).toFixed(2)}M`;
  else if (a >= 1e3) s = `$${Math.round(a / 1e3)}K`;
  else s = `$${Math.round(a)}`;
  return n < 0 ? `(${s})` : s;
}

/** Full-precision money for cashflow table (no cents). */
export function fmtMoneyTable(v) {
  return fmtMoneyDebug(v, 0);
}

/** Full-precision money for cashflow table debug (2 decimal places). */
export function fmtMoneyDebug(v, decimals = 2) {
  if (v == null) return '—';
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  const formatted = abs.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return n < 0 ? `($${formatted})` : `$${formatted}`;
}

export function fmtPctSigned(v) {
  if (!Number.isFinite(v)) return '—';
  return `${(v * 100).toFixed(3)}%`;
}

/** Exposure percent on 0–100 scale (e.g. ending balance ÷ runrate × 100). */
export function fmtExposurePct(percentValue) {
  if (percentValue == null || !Number.isFinite(percentValue)) return '—';
  const pct = Math.abs(percentValue) < 0.05 ? 0 : percentValue;
  return `${pct.toFixed(1)}%`;
}

/** Funding % in marketing cashflow table: 2 decimals below 10%, rounded whole number otherwise. */
export function fmtFundingPct(percentValue) {
  if (percentValue == null || !Number.isFinite(Number(percentValue))) return '—';
  const pct = Number(percentValue);
  if (pct <= 0) return '—';
  if (pct < 10) {
    return `${pct.toFixed(2)}%`;
  }
  return `${Math.round(pct)}%`;
}

/** Annual IRR as percent with exactly 3 decimal places; avoids scientific notation. */
export function fmtIrrPct(decimalRate) {
  const rate = Number(decimalRate);
  if (!Number.isFinite(rate)) return '—';
  const pct = rate * 100;
  if (Math.abs(pct) > 99999.999) return '—';
  const rounded = Math.round(pct * 1000) / 1000;
  return `${rounded.toLocaleString('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })}%`;
}

export function fmtIntegerInput(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return Math.round(num).toLocaleString('en-US');
}

export function parseIntegerInput(value) {
  const cleaned = String(value ?? '').replace(/,/g, '').trim();
  if (cleaned === '') return 0;
  const num = Number(cleaned);
  if (Number.isNaN(num)) return 0;
  return Math.round(num);
}

export function fmtPercentInput(value, fractionDigits = 2) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function parsePercentInput(value, fractionDigits = 2) {
  const cleaned = String(value ?? '').replace(/,/g, '').trim();
  if (cleaned === '') return 0;
  const num = Number(cleaned);
  if (Number.isNaN(num)) return 0;
  const factor = 10 ** fractionDigits;
  return Math.round(num * factor) / factor;
}

export function fmtMoneyHtml(v) {
  const n = Number(v) || 0;
  const text = fmtMoney(n);
  return n < 0 ? `<span class="negative">${text}</span>` : text;
}
